<script lang="ts" setup>
// import { ficmoonConfig, ocereadConfig, rocnovelConfig } from './configs'

import { payConfig as rocnovelConfig } from './configs/rocnovel'
import { payConfig as ocereadConfig } from './configs/oceread'
import { payConfig as ficmoonConfig } from './configs/ficmoon'

import PayPageDefault from './components/PayPage.default.vue'
import PayPageFicmoon from './components/PayPage.ficmoon.vue'
import { loadBrandComponent, loadBrandConfig } from '@/utils/loadBrandConfig'

// 🔥 加载当前品牌配置（构建时 tree-shaking）
const config = loadBrandConfig({
  rocnovel: rocnovelConfig,
  oceread: ocereadConfig,
  ficmoon: ficmoonConfig,
})

// 🔥 加载当前品牌组件（rocnovel 和 oceread 共用 default，ficmoon 用专属组件）
const PayPage = loadBrandComponent({
  rocnovel: PayPageDefault,
  oceread: PayPageDefault,
  ficmoon: PayPageFicmoon,
})
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <PayPage :config="config" />
  </div>
</template>
